import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=11393249&scoped=true"
var script = {}
import style0 from "./LoadingComponent.vue?vue&type=style&index=0&id=11393249&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11393249",
  null
  
)

export default component.exports